import { render } from "./국가암검진예약_신청.vue?vue&type=template&id=45634f45"
import script from "./국가암검진예약_신청.vue?vue&type=script&lang=js"
export * from "./국가암검진예약_신청.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__